import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useIsAdmin from 'App/AccessProvider/useIsAdmin'
import useStyles from 'shared/hooks/useStyle'

import style from './ScanOrManualButtons.style'

const propTypes = {
    onScan: PropTypes.func.isRequired,
    onManual: PropTypes.func.isRequired,
}

const ScanOrManualButtons = ({
    onScan,
    onManual,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(style)

    const { isAdmin } = useIsAdmin()

    return (
        <div css={classes.actions}>
            <Button
                data-testid="start-scan-button"
                css={classes.button}
                onClick={onScan}
            >
                {t('START_SCAN')}
            </Button>
            { isAdmin && (
                <Button
                    data-testid="manual-enter-button"
                    css={classes.button}
                    onClick={onManual}
                >
                    {t('ENTER_MANUALLY')}
                </Button>
            )}
        </div>
    )
}

ScanOrManualButtons.propTypes = propTypes

export default ScanOrManualButtons
